export enum Source {
    Salesbox = "salesbox",
    Widget = "widget",
}
